var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-layout"},[_c('div',{staticClass:"app-board"},[_c('app-header'),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }